import { priceTypingProcess, priceOnFinish } from "../../supplementary_components/priceInputDelegate";
import {API_ROOT, sendRequest } from '../../supplementary_components/requests';
import { BROKER_ADD_CONF } from "../brokers/brokerDelegate";
import { isValidPhoneNumber, phoneNumberTyping, isValidEmailAddress, cityNameFormatter, dateFormatter, timeFormatter, isValidState } from "../../supplementary_components/supplementaryMethods";
import { conductCheck, setAndRemoveError } from "../../general_components/forms/input_fields/InputFieldEventHandlers";
import { cloneDeep } from "lodash";


export const LoadTypeFormatter = Status => {
    switch (Status) {
        case "Full Truck Load": 
            return "FTL";
        case "Partial":
            return "Partial";
        case "High Value":
            return "FTLHighValue";
        case "FTL":
            return "Full Truck Load";
        case "FTLHighValue":
            return "High Value";
        default:
            return "FTL";
    }
}

export const LOAD_ADD_CONF = {
    formAccessLevel: { key: 'RATES' },
    formTitle: "Add Load",
    name: 'addLoadForm',
    addLink: API_ROOT+'loads/add',
    successMessage:'Load was added',
    buildRequestBody:(data, file)=>{ 
        const body = new FormData();
        body.append("loadData", JSON.stringify(data)); 
        if(file === null){
            return body;
        }
        body.append("file", file);
        body.append("fileName", file.name);
        body.append("fileType", 'Rate Con');
        return body;
    },
    // Omit Content-Type so the browser sets multipart boundary; companyId is injected at request time.
    customContentType: {},
    preSendManipulation:(body)=>{
        return body
    },
    columns: [
        {
            label: "Load Number",
            name: "loadNumber",
            mandatory: true,
            
            subMenu : {
                title: "Change Load Type",
                columnTemplate: "1fr ",
                databaseColumnName: 'loadType',
                noNeedToStringify: true,
                columns : [
                    {
                        // Label: "Load Typse",
                        name: "loadType",
                        type: "select",
                        dataset: ["Full Truck Load", "Partial", "High Value"],
                        processBeforeSending : LoadTypeFormatter,
                    }
                ]
            },
            checks: [
                async (loadNumber, column, target) => new Promise(resolve => {
                    try {
                        if(column.ignoreChecks){
                            resolve(null);
                            return;
                        }
                        let formContainer = target.parentElement;
                        let count = 1;
                        while(formContainer.tagName !== "FORM" && count < 10){
                            count++;
                            formContainer = formContainer.parentElement;
                        }
                        const brokerInput = formContainer.querySelector('input[name="broker"]');
                        
                        if(brokerInput){
                            const columnData = {name:"broker"};
                            const removeError = ()=>{
                                resolve(null);
                                setAndRemoveError(columnData, brokerInput, null, false);
                            }
                            if (loadNumber !== '' && brokerInput.getAttribute("data-value") !== '') {
                                const brokerId = parseInt(JSON.parse(brokerInput.getAttribute("data-value")).id);
                                const brokerOldValueId = parseInt(brokerInput.getAttribute("data-old-value-id"));
                                if(brokerOldValueId === brokerId && loadNumber === target.getAttribute("data-old-value")){
                                    removeError();
                                }else if (!isNaN(brokerId)) {
                                    sendRequest("GET", API_ROOT+`loads/duplicateLoadCheck?loadNumber=${loadNumber}&brokerId=${brokerId}`, null, (itIsDuplicate)=>{
                                        if(itIsDuplicate){
                                            setAndRemoveError(columnData, brokerInput, "This load number already exists for the selected broker.", true);
                                            resolve(null);
                                        }else{
                                            removeError();
                                        }
                                    }, ()=>{
                                        removeError();
                                    })
                                }else{
                                    removeError();
                                }
                            }else{
                                removeError();
                            }
                        }
                    } catch (error) {
                        resolve(null);
                    }
                }),
            ],
        },
        {
            label: "Brokerage",
            name: "broker",
            mandatory: true,
            id:"brokerage",
            suggestionsEnabled: true,
            suggestionsLink: API_ROOT+'brokers/namecontaines?pattern=', // link to send request to obtain suggestions
            displayValueGenerator: (val)=>{return `${val['brokerageName']} (${val['city']}, ${val['state']})`},
            displayValueToRawValue: (value)=>{ return value.substr(0, value.indexOf('(')).trim();},
            addNewButton: {label:'Add New Broker', configuration:BROKER_ADD_CONF}, //defines if 'Add New Item' button is shown
            prefillConditioning:(val)=>{
                return {val: val.toLowerCase().match(/[A-Za-z]+ [A-Za-z]+ \([A-Za-z]+, [A-Za-z]+\)/g) !== null ? "" : val, index: 0} ;
            },
            availableOptionDefiningColumnName : 'approved',
            twoPartValue : {
                mainPart : rawData => rawData['approved'] ? `${rawData['brokerageName']} (${rawData['city']}, ${rawData['state']})` : '',
                subPart:  rawData => !rawData['approved'] ? `${rawData['brokerageName']} (${rawData['city']}, ${rawData['state']}) NOT APPROVED` : ""
            },
            checks: [
                async (value, column, target) => new Promise(resolve => {
                    try {
                        if(column.ignoreChecks)resolve(null);
                        if(target.value !== ''){
                            let BROKER_ID = null;
                            let stringifiedBrokerage = target.getAttribute("data-value");
                            let oldValueId = parseInt(target.getAttribute("data-old-value-id"));
                            if(stringifiedBrokerage !== ''){
                                BROKER_ID = parseInt(JSON.parse(stringifiedBrokerage).id);
                            }else{
                                resolve(null);
                            }
                            let formContainer = target.parentElement;
                            let count = 1;
                            while(formContainer.tagName !== "FORM" && count < 10){
                                count++;
                                formContainer = formContainer.parentElement;
                            }
                            const loadNumberInput = formContainer.querySelector('input[name="loadNumber"]');
                            if (loadNumberInput && loadNumberInput.value !== '') {
                                if(oldValueId === BROKER_ID && loadNumberInput.value === loadNumberInput.getAttribute("data-old-value")){
                                    resolve(null);
                                }else if (BROKER_ID && !isNaN(BROKER_ID)) {
                                    sendRequest("GET", API_ROOT+`loads/duplicateLoadCheck?loadNumber=${loadNumberInput.value}&brokerId=${BROKER_ID}`, null, (itIsDuplicate)=>{
                                        resolve(itIsDuplicate ? "This load number already exists for the selected broker." : null);
                                    }, ()=>{
                                        resolve(null);
                                    })
                                }else{
                                    resolve(null);
                                }
                            }else{
                                resolve(null);
                            }
                        }else{
                            resolve(null);
                        }
                    } catch (error) {
                        resolve(null);
                    }
                }),
            ],
            subMenu : {
                databaseColumnName: 'pointOfContact',
                title: "Add Broker Info",
                columnTemplate: "1fr 1fr",
                columns : [
                    {
                        placeholder: "Name",
                        name: "fullName",
                        suggestionsEnabled: true,
                        suggestionsListSource: (val)=>{
                            try {   
                                const list = JSON.parse(document.querySelector('#brokerage').getAttribute('data-value')).pointOfContacts;
                                if (list === null) return null;
                                for (let i = 0; i < list.length;){
                                    const item = JSON.parse(list[i]);
                                    if(!item.fullName){
                                        i++;
                                        continue;
                                    }
                                    if(!item.fullName.toLowerCase().includes(val.toLowerCase()) ){
                                        list.splice(i, 1);
                                    }else{
                                        i++
                                    }
                                }
                                return list.length === 0 ? null : list;
                            } catch (error) {
                                return [];
                            }
                        },
                        displayValueGenerator: (val)=>{
                            val = JSON.parse(val);
                            return `${val['fullName']?val['fullName']:val['email']?val['email']:val['phoneNumber']?val['phoneNumber']:val['telegram']}`
                        },
                        afterSelection:(val)=>{
                            const data = JSON.parse(JSON.parse(val));
                            document.querySelector('#brokerFullName').value = data['fullName'] ? data['fullName'] : "";
                            document.querySelector('#brokerPhoneNumber').value = data['phoneNumber'] ? data['phoneNumber'] : "";
                            document.querySelector('#brokerEmail').value = data['email'] ? data['email'] : '';
                            document.querySelector('#brokerTelegram').value = data['telegram'] ?  data['telegram'] : '';
                        },
                        noValidation:true,
                        id: "brokerFullName"
                    },
                    {
                        placeholder: "Phone Number",
                        name: "phoneNumber",
                        id: "brokerPhoneNumber",
                        filters:[
                            phoneNumberTyping
                        ],
                        onblur:(val, tar)=>{
                            return isValidPhoneNumber(val, tar);
                        }
                    },
                    {
                        placeholder: "Email",
                        name: "email",
                        id: "brokerEmail",
                        onblur:(val, target)=>{
                            return isValidEmailAddress(val, target);
                        }
                    },
                    {
                        placeholder: "Telegram @",
                        name: "telegram",
                        id: "brokerTelegram"
                    }
                ]
            }
        },
        {
            label: "Booked By",
            name: "bookedBy",
            mandatory: true,
            suggestionsEnabled: true,
            suggestionsLink: API_ROOT+'employees/dispatchByName?pattern=', // link to send request to obtain suggestions
            displayValueGenerator: (val)=>{return `${val['firstName']} ${val['lastName']}`},
            displayValueToRawValue: (value)=>{ return value.substr(0, value.indexOf('(')).trim();},
        },
        {
            label: 'Stops',
            type: 'loadPickupDeliveryStops',
            name: "stops",
            
        },
        {
            label: "Payout",
            name: "payout",
            mandatory: true,
            placeholder:'$0.00',
            filters:[
                priceTypingProcess
            ],
            onblur:(val)=>{
                return priceOnFinish(val);
            },
            processBeforeSending:(val)=>{
                return parseFloat(val.replace(/[^0-9.]/g,''))
            },
            subMenu : {
                title: "Add Mileage Info",
                columnTemplate: "1fr 1fr",
                // databaseColumnName: 'mileage',
                noNeedToStringify: true,
                columns : [
                    {
                        Label: "Deadhead",
                        name: "deadhead",
                        placeholder: "Deadhead Miles",
                        isIndependentColumn: true,
                        format:(val)=>{
                            return parseInt(val);
                        }
                    },
                    {
                        Label: "Loaded Miles",
                        name: "mileage",
                        placeholder: "Loaded Miles",
                        isIndependentColumn: true,
                        format:(val)=>{
                            return parseInt(val);
                        }
                    },
                ]
            }
        },
        {
            label:"Load Notes",
            name: 'notes',
            type:'textArea',
            rowCount: 5,
            processBeforeSending:(val)=>{
                const note = { 
                    version: 'v1',
                    authorId: localStorage.getItem("currentUserId"),
                    authorName: localStorage.getItem("currentUserFirstName"),
                    noteMessage: val,
                    urgent: false,
                    relevant: true,
                    lastChangedBy: null
                }
                return val===''?null:[note];
            }
        },
        {
            label: "Rate Confirmation",
            name: 'rateCon',
            type: 'dropBox',
            file: null,
            ignoreAsRegularField: true,
        }
    ]
}
export const RATE_CONF_FETCH_CONF = {
    formAccessLevel: [{ key: 'RATES' }, { key: 'INVOICES', level: 'MANAGE' }],
    formTitle: "Extract Load Info",
    name: 'fetchRCForm',
    addLink: API_ROOT+'loads/fetchRateConf',
    switchToDifferentForm: true,
    switchToDifferentLabel: "Add Manually",
    switchingForm: (currentForm, setFormConf) =>{
        const addFormClone = cloneDeep(LOAD_ADD_CONF);
        if(currentForm.adjustingFollowingConf){
            currentForm.adjustingFollowingConf(addFormClone);
        }
        setFormConf(addFormClone);
    } ,
    customPostSuccessAction: (value, currentForm, setFormConf, payload, event, )=>{
        if("isRateConfirmation" in value && value.isRateConfirmation === false){
            const rateConfLabel = event.target.querySelector('div[id="rateConLabel"]');
            if(rateConfLabel){
                setAndRemoveError({name:"rateCon"}, rateConfLabel, "Couldn't extract load information from this file", true);
            }
            // const btn = document.querySelector('input[type="submit"][form="fetchRCForm"][value="Extract Load Info"]');
            // // if (btn.disabled) {
            // //     btn.disabled = false; // disable after clicking
            // // }
        }else{
            
            const addFormClone = cloneDeep(LOAD_ADD_CONF);
            try {
                for(const column of addFormClone.columns){
                    let defaultVal = null;
                    switch (column.name) {
                        case "rateCon":
                            defaultVal =  payload.get("file")
                            break;
                        case "broker":
                            if(value.broker){
                                defaultVal = `${value.broker['brokerageName']} (${value.broker['city']}, ${value.broker['state']})`;
                                column.predefinedDatValue = JSON.stringify(value.broker);
                                addFormClone.customUseEffect = (ref)=>{
                                    const brokerInput = ref.current.querySelector('input[name="broker"]');
                                    if(column.checks && column.checks.length > 0){
                                        conductCheck(column, brokerInput);
                                    }
                                    const btn = ref.current.querySelector('input[type="submit"][form="addLoadForm"][value="Add Load"]');
                                    if (btn && btn.disabled) {
                                        btn.disabled = false; // disable after clicking
                                    }
                                }
                            }
                            break;
                        case "payout":
                            defaultVal = value.payout ? priceOnFinish(`${value.payout}`) : null;
                            break;
                        case "stops":
                            if(value.stops && value.stops.length > 0){
                                defaultVal = formatStops(value.stops)
                            }
                            break;
                        default:
                            defaultVal = value[column.name] ? value[column.name] : null;
                            break;
                    }
                    column.defaultValue = ()=>{
                        return defaultVal;
                    }
                }
                if(currentForm.adjustingFollowingConf){
                    currentForm.adjustingFollowingConf(addFormClone);
                }
            } catch (error) {}
            setFormConf(addFormClone)
        }
    },
    buildRequestBody:(_, file)=>{ 
        const body = new FormData();
        if(file === null){
            return body;
        }
        body.append("file", file);
        body.append("fileName", file.name);
        body.append("fileType", 'Rate Con');
        return body;
    },
    // Omit Content-Type so the browser sets multipart boundary; companyId is injected at request time.
    customContentType: {},
    preSendManipulation:(body)=>{
        return body
    },
    columns: [
        {
            label: "Rate Confirmation",
            name: 'rateCon',
            type: 'dropBox',
            file: null,
            ignoreAsRegularField: true,
            mandatory:true,
            onceFileLoaded : ()=>{
                setTimeout(() => {
                    try {
                        const btn = document.querySelector('input[type="submit"][form="fetchRCForm"][value="Extract Load Info"]');
                        if (!btn.disabled) {
                            btn.click();
                            // btn.disabled = true; // disable after clicking
                        }
                    } catch (error) {
                        
                    }
                    

                }, 100);
            }
        }

    ]
}

function formatStops(stops){
    for(let i = 0; i < stops.length; i++){
        const stop = stops[i];
        try {
            if("address" in stop && stop.address.city ){
                stop.address.city = cityNameFormatter(stop.address.city);
                stop.address.state = isValidState(stop.address.state);
            }
            if(stop.apptDate){
                stop.apptDate = dateFormatter(stop.apptDate).date;
            }
            if(stop.apptTime){
                stop.apptTime = timeFormatter(stop.apptTime).time;
            }
        } catch (error) {
            console.log(error);
        }
        stops[i] = stop;
    }
    return stops;
}